module.exports = __webpack_public_path__ + "static/media/man.afdfab91.png";